import React from 'react';
import Autosuggest from 'react-autosuggest';
import { withRouter } from 'react-router-dom';

import * as API from '../core/api';
import i18n from '../core/i18n';

function getSuggestions({ users, projects }) {
  const result = [];
  const noResults = users.length === 0 && projects.length === 0;
  if (noResults) {
    return result;
  }

  if (users.length) {
    result.push({
      title: i18n.t('search.titleUsers'),
      items: users,
    });
  }

  if (projects.length) {
    result.push({
      title: i18n.t('search.titleProjects'),
      items: projects,
    });
  }

  return result;
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  return <span>{suggestion.name}</span>;
}

function renderSectionTitle(section) {
  return <strong>{section.title}</strong>;
}

function getSectionSuggestions(section) {
  return section.items;
}

class Search extends React.Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
    };
  }

  componentDidMount() {
    // On route change, close search
    this.props.history.listen((location, action) => {
      this.props.onEscape();
    });
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue,
    });

    if (method === 'escape') {
      this.props.onEscape();
    }
  };

  onSuggestionSelected = (event, { suggestion }) => {
    const isUser = !!suggestion.email;

    isUser
      ? this.props.history.push(`/users/${suggestion._id}`)
      : this.props.history.push(`/projects/${suggestion._id}`);

    this.props.onEscape();
  };

  onSuggestionsFetchRequested = async ({ value, reason }) => {
    const results = await API.get(`search?q=${value.trim()}`);

    this.setState({
      suggestions: getSuggestions(results),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: i18n.t('search.placehoder'),
      value,
      onChange: this.onChange,
    };

    return (
      <Autosuggest
        multiSection={true}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        inputProps={inputProps}
      />
    );
  }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/common/Search.js